import { ClientsTemplate } from "../../Templates/ClientsTemplate";

export const Clients = () => {
  return <ClientsTemplate />;
};
